// image
import python from './../../documents/picturs/python.png';
import are from './../../documents/picturs/are.png';
import csharp from './../../documents/picturs/csharp.jpg';
import rust from './../../documents/picturs/rust.png';

import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import Media from 'react-bootstrap/Media';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Image from 'react-bootstrap/Image'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

function AdsCard(props){
    return(

        <Card className="mt-2 shadow-lg">
          <Row className="ml-1 mr-1">
            <Col xs="6" md="6" lg="6" sm="6">
                  <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.pythonGuide&hl=en">
                  <Card.Title className="text-justify">Python</Card.Title>
                  <Image src={python} fluid rounded className="shadow-lg"/>
                  Download
                  </Card.Link>
            </Col>

            <Col xs="6" md="6" lg="6" sm="6">

                    <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.rust&hl=en">
                    <Card.Title>Rust</Card.Title>
                    <Image src={rust} fluid rounded className="shadow-lg"/>
                    Download
                    </Card.Link>
            </Col>

          </Row>
          <hr/>
          <Row className="ml-1 mr-1">
            <Col xs="6" md="6" lg="6" sm="6">
                  <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.are&hl=en">
                  <Card.Title>Are</Card.Title>
                  <Image src={are} fluid rounded className="shadow-lg"/>
                  Download
                  </Card.Link>
            </Col>

            <Col xs="6" md="6" lg="6" sm="6">
                    <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.Csharp&hl=en">
                    <Card.Title>C-sharp</Card.Title>
                    <Image src={csharp} fluid rounded className="shadow-lg"/>
                    Download
                    </Card.Link>
            </Col>

          </Row>

        </Card>
    );
}

export default AdsCard;
